import { render, staticRenderFns } from "./KpiCards.vue?vue&type=template&id=58264e3f&lang=pug&"
import script from "./KpiCards.vue?vue&type=script&lang=js&"
export * from "./KpiCards.vue?vue&type=script&lang=js&"
import style0 from "./KpiCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports